<script>
import {toString} from "@/utils/date";

export default {
  components: {},
  props: {
    item: Object,
    width: 0,
    calendar: Array,
  },
  data: () => ({
    showClass: '',
    toggleValue: false,
    dialogTableVisible: false,
    tip: "",
    obj1: {},
    obj2: {},
  }),
  methods: {
    change(array, value, scheduleId) {
      let dayQuota = array.find(item => item.dateDay == value.label);
      if (dayQuota.totalQuota == dayQuota.quota) {
        this.$core.notify.info('Нет забронированых туров на эту дату!');
        return;
      }

      this.tip = `${this.item.tour.label} - ${value.value}`
      const duration = this.item.duration;
      const tourId = this.item.tour.value;

      const obj1 = {
        'date.Serialized': dayQuota.date.serialized,
        tourId,
        scheduleId
      };
      this.obj1 = obj1;

      const result = new Date(value.date);
      result.setDate(result.getDate() + duration);

      const obj2 = {
        tourId: tourId,
        dateStart: value.value,
        dateEnd: toString(result)
      }
      this.obj2 = obj2;

      this.dialogTableVisible = true
    },
    correctQuota(array, value) {
      let dayQuota = array.find(item => item.dateDay == value);
      if (dayQuota == undefined)
        return ''
      else
        return `${dayQuota.quota}/${dayQuota.totalQuota}`
    },
    open(value) {
      this.$emit('open', value);
    },
    getClass(index) {
      return index % 2 ? '' : 'blue-light';
    },
    toggle() {
      this.toggleValue = !this.toggleValue
      this.showClass = this.toggleValue ? "hide" : "";
    },
    open2() {
      this.dialogTableVisible = false;
      this.$emit('open2', this.obj2);
    },
    openSeating() {
      this.dialogTableVisible = false;
      this.$emit('change', this.obj1);
    },
  },
};
</script>
<template>
  <div>
    <el-dialog width="350px"
               :title="tip"
               class="el-dialog__context"
               :visible.sync="dialogTableVisible">
      <div>
        <el-row>
          <el-link type="primary" @click="openSeating" >Рассадка</el-link>
        </el-row>
        <el-row>
          <el-link type="success" @click="open2">Проведение туров</el-link>
        </el-row>
      </div>
    </el-dialog>
    <el-row class="table-board__body-tour">
      <el-col :span="21" style="height:calc(100% - 1px);border-bottom: 1px solid #d5dfe7;color: rgba(0,0,0,0.8);    padding-top: 6px;">
        <span style="color:rgba(0,0,0,0.8);z-index: 5;padding: 5px;cursor: pointer; opacity:1"  @click="open(item.tour)">  {{item.tour.label}} </span>
      </el-col>
      <el-col :span="3" style="height:calc(100% - 1px);border-bottom: 1px solid #d5dfe7;color: rgba(0,0,0,0.8)">
        <div class="" style="width: 100%">
          <BtnIcon
          class="btn-transparent"
          :class="showClass"
          slot="btn"
          @click="toggle"
          icon="el-icon-arrow-down"
        /></div>
      </el-col>
    </el-row>
    <div class="body-tour-list" :class="showClass">
      <el-row class="table-board__body-schedule" v-for="(tourBoardScheduleItem, index) in item.tourBoardScheduleItems" :key="index" :class="getClass(index)">
        <el-col :span="3" style="height: 100%">
          <span style="height: 30px; font-size:14px;text-align: center;color: rgba(0,0,0,0.8)"> {{tourBoardScheduleItem.endDate.serialized}} - {{tourBoardScheduleItem.startDate.serialized}}</span>
        </el-col>
        <el-col :span="21" style="display: flex; justify-content:space-between; height: 100%">
          <div class="cell"  v-for="(col, j) in calendar" :key="j" v-bind:style="{ width: width, backgroundColor: col.Color}">
            <div class='cell-number' @click="change(tourBoardScheduleItem.tourBoardScheduleDateItems, col, tourBoardScheduleItem.schedule.value)">
              <span style="height: 26px; font-size:14px;color: rgba(0,0,0,0.8)"> {{correctQuota(tourBoardScheduleItem.tourBoardScheduleDateItems, col.label)}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style lang="scss">
.el-dialog__context {
  .el-dialog__title {
    padding: 10px;
    padding-bottom: 10px;
    padding-left: 0px
  }

  .el-dialog__body {
    padding: 13px 20px;
  }
}
.body-tour-list{
  &.hide{
    display: none;
  }
}
.table-board__body {
  &-tour {
    background:  #8ac15d;
    opacity:0.8;
    border-bottom: none;
    height: 32px;
    .btn-transparent {
      border-radius: 0px;
      float: right;
      border-color: transparent;
      box-shadow: none;
      &.hide {
        transform: rotate(180deg);
      }
      outline: none;
    }
    .el-col-3 {
      span {
        opacity: 1;
        z-index: 4;
        color: black;
        margin-top: 3px;
        display: block;
        width: 100%;
        font-size: 18px;
        line-height: 20px;
        padding: 3px 3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
  }
  &-schedule{
    border-right: 1px solid #d5dfe7;
    flex-shrink: 0;
    position: relative;
    line-height: 30px;
    background: #f3f5f4;
    &.blue-light{
     background: #ebeef5;
    }
    &:hover {
      background: #fff7c8;
    }
    height: 30px;
    .cell {
      border-left: solid #d5dfe7 1px;
      word-break: normal;
      white-space: nowrap;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      &:last-child {
        border-right: solid black 1px;
      }

      .cell-number{
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
</style>
